<template lang="html">
  <div>
    <vx-tooltip
      :delay="tooltipDelay"
      :text="tooltipText"
      :tooltipPosition="tooltipPosition"
    >
      <feather-icon
        icon="FileTextIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-popup :title="$t('confirm')" :active.sync="active">
        <p>{{$t('a_report_will_be_generated')}}. {{$t('are_you_sure')}}</p>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
             ref="loadableButton" 
             id="link-button-loading" 
             class="w-full vs-con-loading__container" 
              color="primary"
              type="filled"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="submit"
              >{{submitButtonText}}</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit"
              @click="confirmActive = false"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
  </div>
</template>

<script>
import invoice from '@/http/requests/invoice'
export default {
  props: {
    btnColor: {
      type: String,
      default: 'primary'
    },
    btnType: {
      type: String,
      default: 'border'
    },
    btnIcon: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'button'
    },
    popupTitle: {
      type: String,
      default: 'title'
    },
    tooltipDelay: {
      type: String,
      default: '1.5s'
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    tooltipText: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: false,
      loading:false,
      submitButtonText:this.$i18n.messages[this.$i18n.locale].submit
    }
  },
  methods: {
    open() {
      this.active = true
    },
    close() {
      this.active = false
    },
    submit() {
      this.loading = true
      this.close()
      let params = {
          invoiceId:this.data.InvoiceId
      }
      invoice
        .generateExclusiveExpenseReport(params)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Action',
            text: this.$i18n.messages[this.$i18n.locale].report_regenerated
          })
          this.loading = false
        })
        .catch(err => {
          if (422 === err.response.status) {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: err.response.data.msg
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: 'SERVER ERROR'
            })
          }
          this.loading = false
        })
    }
  }
}
</script>
